import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20digital%20database%20and%20data%20network%20visualization%20with%20glowing%20nodes%20and%20connected%20lines%20in%20warm%20amber%20and%20golden%20tones%20on%20dark%20background%2C%20futuristic%20technology%20concept%2C%20clean%20minimal%20geometric%20patterns%2C%20soft%20atmospheric%20lighting%2C%20cinematic%204k%20quality%2C%20no%20text%20no%20people&width=1800&height=900&seq=hero-main-bg&orientation=landscape"
          alt="JavBus 影片资料库平台使用指南"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto animate-fade-in-up">
          <span className="inline-block px-3 py-1 rounded-full bg-white/15 backdrop-blur-sm text-white/90 text-xs font-label mb-4 md:mb-6">
            影片资料库平台使用指南
          </span>
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-4 md:mb-6">
            JavBus 官方入口
            <br />
            与完整使用指南
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-xl mx-auto mb-6 md:mb-8 leading-relaxed">
            为您提供 JavBus 的最新访问入口、功能介绍、搜索技巧及常见问题解答，
            帮助您快速找到所需内容，畅享完整的 JavBus 使用体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/latest-address"
              className="whitespace-nowrap w-full sm:w-auto px-6 py-3 bg-primary-500 text-white font-medium text-sm rounded-md hover:bg-primary-600 transition-colors"
            >
              查看最新地址
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category/search-tips"
              className="whitespace-nowrap w-full sm:w-auto px-6 py-3 bg-white/15 backdrop-blur-sm text-white font-medium text-sm rounded-md hover:bg-white/25 transition-colors"
            >
              搜索技巧指南
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}